var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatients(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.439697C12.068 0.439697 15.426 3.46728 15.934 7.3854L18.184 10.9146C18.332 11.1469 18.302 11.493 17.959 11.6406L16 12.4763V15.3981C16 16.5001 15.105 17.3926 14 17.3926H12.001L12 20.3843H3V16.7005C3 15.5238 2.564 14.4099 1.756 13.4047C0.657 12.0385 0 10.3043 0 8.41753C0 4.01177 3.582 0.439697 8 0.439697ZM8 2.43416C4.686 2.43416 2 5.11271 2 8.41753C2 9.79869 2.468 11.1031 3.316 12.1571C4.41 13.5174 5 15.0661 5 16.7005V18.3898H10L10.002 15.3981H14V11.1619L15.55 10.4997L14.007 8.08146L13.95 7.64069C13.566 4.67892 11.024 2.43416 8 2.43416ZM7.47 6.18673L8 6.71526L8.53 6.18673C9.214 5.50462 10.322 5.50462 11.005 6.18673C11.689 6.86784 11.689 7.97277 11.005 8.65387L8 11.6515L4.995 8.65387C4.311 7.97277 4.311 6.86784 4.995 6.18673C5.678 5.50462 6.786 5.50462 7.47 6.18673Z",
    fill: "#00758B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatients);
export default __webpack_public_path__ + "static/media/patients.a4f59c14d3dfea86d4e41647c16d51c5.svg";
export { ForwardRef as ReactComponent };